import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap'
import { LoadingSpinner } from './../../components'
import CashMahanService from './../../services/cashMahan/CashMahanService'
import CashMahanStatusBadge from './CashMahanStatusBadge'
import {
  apiErrorMessage,
  customerLabel,
  displayText,
  formatDate,
  formatMoney,
  isForbidden,
  isSuccess,
  paymobCallback,
  recordId,
  rtlProps,
  technicianId,
  technicianLabel,
  unwrapData
} from './cashMahanUtils'

function DetailRow(props) {
  return (
    <p>
      <i className="icon-arrow-right-circle"></i>
      <span style={{ marginLeft: 6 }}>
        {props.label}:
        <span style={{ fontWeight: 'bold', marginLeft: 8, ...((props.rtl && rtlProps(props.value).style) || {}) }}>
          {props.value}
        </span>
      </span>
    </p>
  )
}

export default class PaymentRequestDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: '',
      item: props.item || null
    }
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate(prevProps) {
    const prevId = this.requestId(prevProps)
    const nextId = this.requestId(this.props)
    if (prevId !== nextId) {
      this.load()
    }
  }

  requestId(props) {
    const source = props || this.props
    if (source.id) {
      return source.id
    }
    if (source.match && source.match.params) {
      return source.match.params.id
    }
    return recordId(source.item)
  }

  load() {
    const id = this.requestId()
    if (!id) {
      this.setState({ error: 'Missing payment request id', item: this.props.item || null })
      return
    }
    this.setState({ loading: true, error: '' })
    CashMahanService.getPaymentRequest(id, (res) => {
      if (isForbidden(res)) {
        this.setState({ loading: false })
        if (this.props.history) {
          this.props.history.push('/403')
        }
        return
      }
      if (!isSuccess(res)) {
        this.setState({
          loading: false,
          error: apiErrorMessage(res),
          item: this.props.item || null
        })
        return
      }
      const data = unwrapData(res)
      this.setState({
        loading: false,
        error: '',
        item: data.paymentRequest || data.payment || data
      })
    })
  }

  renderCallback(callback) {
    if (!callback) {
      return <p style={{ color: '#777' }}>No Paymob callback information is available.</p>
    }
    const rows = []
    Object.keys(callback).forEach((key) => {
      const value = callback[key]
      if (value && typeof value === 'object') {
        rows.push(
          <tr key={key}>
            <td style={{ fontWeight: 'bold' }}>{key}</td>
            <td><pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(value, null, 2)}</pre></td>
          </tr>
        )
      } else {
        rows.push(
          <tr key={key}>
            <td style={{ fontWeight: 'bold' }}>{key}</td>
            <td>{displayText(value)}</td>
          </tr>
        )
      }
    })
    return (
      <Table hover bordered striped responsive size="md">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    )
  }

  renderContent() {
    const item = this.state.item || {}
    const fixerId = technicianId(item)
    return (
      <div>
        {this.state.error ? (
          <p style={{ color: '#a91010' }}>{this.state.error}</p>
        ) : null}
        <Row>
          <Col md="6">
            <DetailRow label="Technician" value={technicianLabel(item)} rtl />
            <DetailRow label="Customer" value={customerLabel(item)} rtl />
            <DetailRow label="Reference" value={displayText(item.reference)} />
            <DetailRow label="Paymob transaction ID" value={displayText(item.paymobTransactionId)} />
            <p>
              <i className="icon-arrow-right-circle"></i>
              <span style={{ marginLeft: 6 }}>
                Status: <span style={{ marginLeft: 8 }}><CashMahanStatusBadge item={item} /></span>
              </span>
            </p>
          </Col>
          <Col md="6">
            <DetailRow label="Service amount" value={formatMoney(item.serviceAmount)} />
            <DetailRow label="Gateway fee" value={formatMoney(item.gatewayFee)} />
            <DetailRow label="Technician amount" value={formatMoney(item.technicianAmount)} />
            <DetailRow label="Created date" value={formatDate(item.createdAt)} />
          </Col>
        </Row>
        {fixerId ? (
          <Button
            className='actionsBtn'
            onClick={() => this.props.history && this.props.history.push(`/cash-mahan/technicians/${fixerId}/wallet`)}
          >
            View technician wallet
          </Button>
        ) : null}
        <h6 style={{ marginTop: 20, fontWeight: 'bold' }}>Paymob callback</h6>
        <p style={{ color: '#777', fontSize: 13 }}>
          Secrets, HMAC values, and raw card or customer payment data are never shown.
        </p>
        {this.renderCallback(paymobCallback(item))}
        <LoadingSpinner loading={this.state.loading} />
      </div>
    )
  }

  render() {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      return (
        <div className="app align-items-center">
          <Card>
            <CardHeader className='shadow'>
              <i className="fa fa-align-justify"></i>
              <span style={{ marginLeft: 6 }}>Payment request details</span>
              <Button className='actionsBtn' style={{ float: 'right' }} onClick={() => this.props.history.goBack()}>Back</Button>
            </CardHeader>
            <CardBody className='shadow'>
              {this.renderContent()}
            </CardBody>
          </Card>
        </div>
      )
    }
    return this.renderContent()
  }
}
